<template>
    <div>
        <div class="entrada-token">
            <input v-for="(digito, indice) in arrayOtp" :key="indice" v-model="arrayOtp[indice]" @input="aoInserir(indice)"
            @keydown="aoPressionarTecla(indice, $event)" maxlength="1" :type="tipo"
            class="form-control text-center mr-2" :disabled="desabilitado" :ref="'input' + indice"
            @paste="aoColar($event)" style="width: 45px;" />
        </div>
        <b-row>
            <b-col class="my-auto" cols="12" sm="12">
                <div v-if="mostraTempoLocal" class="tempo-restante mt-4 d-flex flex-column align-items-center justify-content-center">
                    <span>Tempo restante: <i class="fa fa-clock-o"></i> {{ tempoRestanteFormatado }}</span>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        valor: {
            type: String,
            default: '',
        },
        tamanho: {
            type: Number,
            default: 6,
        },
        desabilitado: {
            type: Boolean,
            default: false,
        },
        tipo: {
            type: String,
            default: 'text',
            validator(valor) {
                return ['text', 'number', 'password'].includes(valor);
            }
        },
        mostraTempo: {
            type: Boolean,
            default: false,
        },
        tempo: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            arrayOtp: Array(this.tamanho).fill(''),
            tempoRestante: this.calcularTempoRestante(),
            intervalo: null,
            mostraTempoLocal: this.mostraTempo
        };
    },
    computed: {
        tipoEntrada() {
            return this.tipo;
        },
        tempoRestanteFormatado() {
            const minutos = Math.floor(this.tempoRestante / 60);
            const segundos = this.tempoRestante % 60;
            return `${minutos}:${segundos < 10 ? '0' : ''}${segundos}`;
        }
    },
    watch: {
        valor(novoValor) {
            this.arrayOtp = novoValor.split('');
        },
        arrayOtp: {
            handler(novoValor) {
                this.$emit('input', novoValor.join(''));
                if (novoValor.join('').length === this.tamanho) {
                    this.$emit('completo', novoValor.join(''));
                } else {
                    this.$emit('completo', '');
                }
            },
            deep: true,
        },
        tamanho(novoTamanho) {
            this.arrayOtp = Array(novoTamanho).fill('');
        },
        tempo() {
            console.log(123)
            this.mostraTempoLocal = this.mostraTempo
            this.tempoRestante = this.calcularTempoRestante();
            this.iniciarContagemRegressiva();
        }
    },
    methods: {
        aoInserir(indice) {
            if (this.arrayOtp[indice].length > 1) {
                this.arrayOtp[indice] = this.arrayOtp[indice].slice(-1);
            }
            if (indice < this.tamanho - 1 && this.arrayOtp[indice] !== '') {
                this.$nextTick(() => {
                    this.$refs[`input${indice + 1}`].focus();
                });
            }
        },
        aoPressionarTecla(indice, evento) {
            if (evento.key === 'Backspace') {
                if (this.arrayOtp[indice] === '' && indice > 0) {
                    this.$nextTick(() => {
                        const entradaAnterior = this.$refs[`input${indice - 1}`];
                        this.arrayOtp[indice - 1] = '';
                        entradaAnterior.focus();
                    });
                } else {
                    this.$nextTick(() => {
                        this.arrayOtp[indice] = '';
                    });
                }
            } else if (evento.key === 'ArrowRight' && indice < this.tamanho - 1) {
                this.$nextTick(() => {
                    const proximaEntrada = this.$refs[`input${indice + 1}`];
                    proximaEntrada.focus();
                });
            } else if (evento.key === 'ArrowLeft' && indice > 0) {
                this.$nextTick(() => {
                    const entradaAnterior = this.$refs[`input${indice - 1}`];
                    entradaAnterior.focus();
                });
            }
        },
        aoColar(evento) {
            evento.preventDefault()
            const dadosColados = evento.clipboardData.getData('text').trim();
            if (dadosColados.length === this.tamanho && !isNaN(dadosColados)) {
                this.arrayOtp = dadosColados.split('');
                this.$emit('input', dadosColados);
                this.$emit('completo', dadosColados);
                this.$nextTick(() => {
                    const ultimaEntrada = this.$refs[`input${this.tamanho - 1}`];
                    ultimaEntrada.focus();
                });
            }
        },
        calcularTempoRestante() {
            const agora = Math.floor(Date.now() / 1000);
            return Math.max(this.tempo - agora, 0);
        },
        iniciarContagemRegressiva() {
            if (this.intervalo) {
                clearInterval(this.intervalo);
            }
            if (this.tempoRestante > 0) {
                this.intervalo = setInterval(() => {
                    this.tempoRestante--;
                    if (this.tempoRestante <= 0) {
                        clearInterval(this.intervalo);
                        this.mostraTempoLocal = false;
                        this.$emit('fimTempo');
                    }
                }, 1000);
            }else{
                this.mostraTempoLocal = false;
            }
        }
    },
    mounted() {
        this.arrayOtp = Array(this.tamanho).fill('');
        if (!this.desabilitado) {
            this.$nextTick(() => {
                this.$refs['input0'].focus();
            });
        }
        if (this.mostraTempo && this.tempo > 0) {
            this.iniciarContagemRegressiva();
        }
    },
    beforeDestroy() {
        if (this.intervalo) {
            clearInterval(this.intervalo);
        }
    }
};
</script>

<style scoped>
.entrada-token {
    display: flex;
    justify-content: center;
    align-items: center;
}

input {
    width: 45px;
    height: 45px;
    font-size: 20px;
    text-align: center;
    margin-right: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

@media (max-width: 768px) {
    input {
        width: 35px;
        height: 35px;
        font-size: 16px;
    }
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}

input:disabled {
    background-color: #e9ecef;
}

.tempo-restante {
    font-size: 12px;
    margin-left: 10px;
}
</style>
